// extracted by mini-css-extract-plugin
module.exports = {"container":"_1O8DQHaBalb7ydw1_ljZud","title":"f8m0y5L3tKAFHnXQRhKuY","subtitle":"_3KFvR7FIj5o4Mb1Hk_mfYA","logoSantander":"_5mi53WjCpVNa4yn6F2eaE"};